import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '../shared/lib/themeContext';
import { SidebarProvider } from '../widgets/sidebar/SidebarContext';
import { PermissionsProvider } from '../shared/lib/permissionsContext';
import { Sidebar } from '../widgets/sidebar';
import { ProtectedRoute, PagePermissionRoute } from '../shared/components';
import { TicketsPage } from '../pages/tickets';
import { DashboardPage } from '../pages/dashboard';
import { SearchPage } from '../pages/search';
import { AdminPage } from '../pages/admin';
import { TemplatesPage } from '../pages/templates';
import { CategoriesPage } from '../pages/categories';
import { ClientsPage } from '../pages/clients';
import { SettingsPage } from '../pages/settings';
import { LoginPage } from '../pages/auth';
import { SelectGlobalStyles } from '../shared/ui/Select/SelectGlobalStyles';
import * as S from './App.styles';

function ProtectedLayout({ children }: { children: React.ReactNode }) {
  return (
    <S.AppContainer>
      <Sidebar />
      {children}
    </S.AppContainer>
  );
}

function AppContent() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <PagePermissionRoute page="dashboard">
              <ProtectedLayout>
                <DashboardPage />
              </ProtectedLayout>
            </PagePermissionRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/:id?"
        element={
          <ProtectedRoute>
            <PagePermissionRoute page="tickets">
              <ProtectedLayout>
                <TicketsPage />
              </ProtectedLayout>
            </PagePermissionRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/search"
        element={
          <ProtectedRoute>
            <PagePermissionRoute page="search">
              <ProtectedLayout>
                <SearchPage />
              </ProtectedLayout>
            </PagePermissionRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/templates"
        element={
          <ProtectedRoute>
            <PagePermissionRoute page="templates">
              <ProtectedLayout>
                <TemplatesPage />
              </ProtectedLayout>
            </PagePermissionRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <ProtectedLayout>
              <AdminPage />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories"
        element={
          <ProtectedRoute>
            <PagePermissionRoute page="categories">
              <ProtectedLayout>
                <CategoriesPage />
              </ProtectedLayout>
            </PagePermissionRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/clients"
        element={
          <ProtectedRoute>
            <PagePermissionRoute page="clients">
              <ProtectedLayout>
                <ClientsPage />
              </ProtectedLayout>
            </PagePermissionRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <PagePermissionRoute page="settings">
              <ProtectedLayout>
                <SettingsPage />
              </ProtectedLayout>
            </PagePermissionRoute>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <SidebarProvider>
        <PermissionsProvider>
          <BrowserRouter>
            <SelectGlobalStyles />
            <AppContent />
          </BrowserRouter>
        </PermissionsProvider>
      </SidebarProvider>
    </ThemeProvider>
  );
}

export default App;

